module.exports = __webpack_public_path__ + "media/images/icon-mask-bread-9e9b036a61d41b91db377ce25fc311c9.png";